export default __webpack_public_path__ + "static/media/fasting_unexpected.b1463cef.jpg";